import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed } from "features/notification/hooks"
import {
  getFoodDetails,
  setDetailsBackPath,
  setFoodDetails,
} from "../../foodSlice"
import { useEffect } from "react"
import {
  generatePath,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom"
import PATHS from "router/paths"
import { IMyFood } from "model/food/types/myfood.types"
import { useMealTypeQueryParams } from "features/meal/hooks"

export const useMyFoodDetails = () => {
  const params = useParams()
  const id = params.id
  const foodDetails = useAppSelector((state) => state.food.foodDetails)
  const getFoodDetailsLoading = useAppSelector(
    (state) => state.food.getFoodDetailsLoading,
  )
  const getFoodDetailsFailed = useAppSelector(
    (state) => state.food.getFoodDetailsFailed,
  )

  useFailed(getFoodDetailsFailed)

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (id && foodDetails?.id !== id) {
      dispatch(getFoodDetails(id))
    }
  }, [dispatch])

  return {
    foodDetails,
    getFoodDetailsLoading,
  }
}

export const useGoToMyFoodDetails = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const mealTypeQueryParam = useMealTypeQueryParams()

  const onGoToFoodDetails = (food: IMyFood, path?: string) => {
    dispatch(setFoodDetails(food))

    navigate(
      generatePath(`${PATHS.app.food.details}${mealTypeQueryParam}`, {
        id: food.id,
      }),
    )
    dispatch(setDetailsBackPath(path ?? location.pathname))
  }

  return onGoToFoodDetails
}

export const useFoodDetailsOnBack = () => {
  const detailsBackPath = useAppSelector((state) => state.food.detailsBackPath)
  const navigate = useNavigate()

  return () => navigate(detailsBackPath ?? PATHS.app.root)
}
